import {Id, Slide, toast, ToastOptions} from 'react-toastify';

const DEFAULT_TOASTIFY_CONFIGURATION = {
  autoClose: 5000,
  draggable: false,
  closeOnClick: true,
  hideProgressBar: false,
  pauseOnFocusLoss: false,
  position: 'top-center',
  progress: undefined,
  theme: 'light',
  transition: Slide,
} as ToastOptions;

export const error = (message: string): Id => toast.error(message, DEFAULT_TOASTIFY_CONFIGURATION);
export const success = (message: string): Id => toast.success(message, DEFAULT_TOASTIFY_CONFIGURATION);
export const warning = (message: string): Id => toast.warning(message, DEFAULT_TOASTIFY_CONFIGURATION);

export const Toaster = {
  error,
  success,
  warning,
};
